import { Component, OnInit, Input, ElementRef } from '@angular/core';
import { SetService, EventService, PageService, FormControlService } from 'ngx-block-core';
import { selectSize, selectThemeSize, iconTheme } from "../../../data/data";
import { HttpService } from 'ngx-block-core';
import { NzModalService } from 'ng-zorro-antd';
import { NzNotificationService, NzMessageService } from 'ng-zorro-antd';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-sucu05-button0010009',
    templateUrl: './sucu05-button0010009.component.html',
    styles: [
    ]
})
export class Sucu05Button0010009Component implements OnInit {
    nzLoading = false;
    @Input() local = false;
    @Input() static = false;
    @Input() blockid = "-1";
    @Input() layoutid = "-1";
    @Input() sets = {
        blockCode: "sucublock29",
        blockId: "",
        blockName: "提交按钮",
        layoutId: "",
        blockType: 'formButton',
        blockChildType: 'submit',
        versionCode: 19,
        events: [
            {
                label: "隐藏",
                value: "pageShow",
                data: {
                    setParams: ["隐藏值", '显示值，可不填', '备用']
                }
            },
            {
                label: "快速模式切换",
                value: "fastForm",
                data: {
                    setParams: ["快速值", '转圈值', '备用']
                }
            }
        ],
        styles: {
            nzText: "提交",
            nzType: "default",
            nzSize: "default",
            nzBgColor: "",
            nzIcon: {
                nzIconType: '',
                nzIconTheme: '',
                nzIconColor: '',
            },
            nzOpen: true,
            nzConfirm: {
                nzShow: false,
                nzTitle: "提示",
                nzContent: "确定吗？"
            },
            nzShow: true,
            nzShowValue: "",
            nzFastClick: false,
            nzFastData: {
                nzResetId: "",
                nzResetFormName: "",
                nzCheck: false,
                nzCheckGroupName: ''
            },
        },
        datas: {

            nzLog: "",
            nzLogSet: {
                defaultTitle: "SN:"
            },
            nzFocus: {
                nzFocus1: "",
                nzFocus2: "",
                nzFocus3: "",
            },
            nzClickFocus: true,
            nzECO: true,
            nzSIC: "",
            nzDataSource: "",
            nzDoEventFail: true,
            nzEvents: [

            ],
            nzEventsDatas: {
            },
            nzNeedNextCheckBox: false,
            nzNeedRefresh: false,
            nzNeedFromRefresh: false,
            nzProcedure: {
                nzProcedureIsNeed: false,
                nzProcedureTriggerPosition: "default",
                nzProcedureName: "",
                nzProcedureView: "",
                nzServiceParam: [],
                nzServiceParamDetail: { "sequ": 1 }

            },
            nzOtherData: [],
            nzOtherFormCheck: []
        }
    };
    setData = []
    @Input() httpUrls = {
        dynamicProcedure: {
            needChange: true,
            url: "/system/dynamicProcedure",
            name2: "proData",
        },
    }
    setDataInit() {
        this.setData = [
            {
                tabName: '样式',
                datas: [
                    {
                        type: 'styles',
                        data: [
                            {
                                name: 'input',
                                inputs: { nzText: "积木名称 : ", nzKeys: ['blockName'] }
                            },
                            {
                                name: 'input',
                                inputs: {
                                    nzText: "按钮名称 : ", nzKeys: ['styles', 'nzText']
                                }
                            },
                            {

                                name: 'select',
                                inputs: {
                                    nzText: "主题 : ", nzKeys: ['styles', 'nzType'], nzData: selectThemeSize
                                }
                            },
                            {
                                name: 'radio',
                                inputs: { nzText: "图标主题:", nzKeys: ['styles', 'nzIcon', 'nzIconTheme'], nzData: iconTheme, },
                                outputs: {
                                    ngModelChange: (event) => {


                                        if (event == 'twotone') {

                                            this.setService.setDatas[this.blockid][2]['datas'][0]['data'][5]['show'] = true;

                                        } else {
                                            this.setService.setDatas[this.blockid][2]['datas'][0]['data'][5]['show'] = false;

                                        }


                                        this.setService.onReLoadbBlock(this.layoutid);

                                    }
                                }
                            },
                            {
                                name: 'input',
                                inputs: { nzText: "图标 : ", nzKeys: ['styles', 'nzIcon', 'nzIconType'], nzPopContent: ['填入type,请参照官方文档:', 'https://ng.ant.design/components/icon/zh'] },
                                outputs: { ngModelChange: () => { if (this.sets.styles.nzIcon.nzIconType == '') this.setService.onReLoadbBlock(this.layoutid) } }
                            },
                            {
                                name: 'color', show: this.sets.styles.nzIcon.nzIconType == 'twotone',
                                inputs: {
                                    nzText: "图标颜色 : ", nzKeys: ['styles', 'nzIcon', 'nzIconColor']
                                }
                            },
                            {
                                name: 'color',
                                inputs: {
                                    nzText: "背景颜色 : ", nzKeys: ['styles', 'nzBgColor']
                                }
                            },
                            {
                                name: 'radio',
                                inputs: { nzText: "大小 : ", nzKeys: ['styles', 'nzSize'], nzData: selectSize }
                            },
                            {
                                name: 'switch',
                                inputs: { nzText: "显示继续创建 : ", nzKeys: ['datas', 'nzNeedNextCheckBox'], nzPopContent: "弹框页面专用" }
                            },
                            {
                                name: 'switch',
                                inputs: { nzText: "成功后刷新 : ", nzKeys: ['datas', 'nzNeedRefresh'], nzPopContent: "弹框页面专用" }
                            },
                            {
                                name: 'switch',
                                inputs: { nzText: "开放按钮 : ", nzKeys: ['styles', 'nzOpen'] }
                            },



                            {
                                name: 'switch',
                                inputs: { nzText: "显示按钮 : ", nzKeys: ['styles', 'nzShow'] }
                            },

                            {
                                name: 'switch',
                                inputs: { nzText: "表单刷新 : ", nzKeys: ['datas', 'nzNeedFromRefresh'], nzPopContent: ['在按钮仅调用存储过程不执行表单提交，且非快速提交的状态下需要开启'] }
                            },
                            {
                                name: 'switch',
                                inputs: { nzText: "快速提交 : ", nzKeys: ['styles', 'nzFastClick'] }
                            },
                            {
                                name: 'select',
                                inputs: { nzText: "快速提交积木 : ", nzKeys: ['styles', 'nzFastData', 'nzResetId'], nzData: this.setService.getBlock('formBlock', "*") },
                            },
                            {
                                name: 'input',
                                inputs: { nzText: "积木FormId : ", nzKeys: ['styles', 'nzFastData', 'nzResetFormName'], nzPopContent: ['请前往积木的表单配置页查找'] },
                            },
                            {
                                name: 'switch',
                                inputs: { nzText: "快速重复检测 : ", nzKeys: ['styles', 'nzFastData', 'nzCheck'] }
                            },
                            {
                                name: 'input',
                                inputs: { nzText: "组检测FormId : ", nzKeys: ['styles', 'nzFastData', 'nzCheckGroupName'], nzPopContent: ['请前往积木的表单配置页查找'] },
                            },


                            { name: 'nzConfirm' }
                        ]
                    },
                ]
            },
            {
                tabName: '功能',
                datas: [
                    {
                        type: 'datas',
                        data: [
                            {
                                name: 'switch',
                                inputs: { nzText: "失败执行事件 : ", nzKeys: ['datas', 'nzDoEventFail'] }
                            },
                            { name: "nzEvents" },
                            { name: "nzOtherFormCheck" },
                            { name: "nzDrawerLog" },
                            {
                                name: 'select',
                                inputs: { nzText: "SIC积木 : ", nzKeys: ['datas', 'nzSIC'], nzData: this.setService.getBlock('table', "*") },
                            },
                            {
                                name: 'switch',
                                inputs: { nzText: "ECO : ", nzKeys: ['datas', 'nzECO'] }
                            },
                            {
                                name: 'switch',
                                inputs: { nzText: "ECO : ", nzKeys: ['datas', 'nzECO'] }
                            },
                            {
                                name: 'switch',
                                inputs: { nzText: "点击焦点 : ", nzKeys: ['datas', 'nzClickFocus'] }
                            },


                        ]
                    },
                ]
            },
            {
                tabName: '业务存储',
                datas: [
                    {
                        type: 'datas',
                        data: [

                            {
                                name: 'nzProcudure',
                                inputs: { nzProcedure: this.sets.datas.nzProcedure, nzServiceParam: this.sets.datas.nzProcedure.nzServiceParam, nzServiceParamDetail: this.sets.datas.nzProcedure.nzServiceParamDetail }
                            },
                            {
                                name: 'nzServiceParam',
                                inputs: { nzProcedure: this.sets.datas.nzProcedure, nzServiceParam: this.sets.datas.nzProcedure.nzServiceParam, nzServiceParamDetail: this.sets.datas.nzProcedure.nzServiceParamDetail, nzNeedProcedure: true }
                            },
                            {
                                name: 'nzOtherData',
                            },
                            {
                                name: 'select',
                                inputs: { nzText: "存储焦点1 : ", nzKeys: ['datas', 'nzFocus', 'nzFocus1'], nzData: this.setService.getBlock('formBlock', "*") },
                            },
                        ]
                    },
                ]
            },
        ]

    }

    constructor(
        public setService: SetService,
        public httpService: HttpService,
        public eventService: EventService,
        public pageService: PageService,
        private modalService: NzModalService,
        private notification: NzNotificationService,
        private message: NzMessageService,
        private elementRef: ElementRef,
        private activatedRoute: ActivatedRoute,
        private formControlService: FormControlService
    ) { }
    formLayout = true;
    path
    ngOnInit() {
        this.path = this.pageService.getPathByRoute(this.activatedRoute);
        if (!this.local) {//非本地
            if (!this.static) {//非静态
                if (this.setService.blocksort[this.blockid]['sets'] !== '{}') {
                    this.sets = this.setService.blocksort[this.blockid]['sets'];
                } else {
                    this.setService.blocksort[this.blockid]['sets'] = this.sets;
                }
                this.sets.blockId = this.blockid;
                this.sets.layoutId = this.layoutid;
                this.autoUpdate();
                this.setDataInit();
                if (typeof this.setService.setDatas[this.blockid] == 'undefined') {
                    this.setService.setDatas[this.blockid] = this.setData;
                }
                this.setService.blockPublicSets[this.blockid + "Urls"] = this.httpUrls;
            }
            else {//静态
                if (typeof this.sets == "string")
                    this.sets = JSON.parse(<any>this.sets);
                this.blockid = this.sets.blockId;
                this.layoutid = this.sets.layoutId;
                this.autoUpdate();
            }
        }
        if (typeof this.setService.pageDatas['form_' + this.layoutid] == 'undefined') {
            this.formLayout = false;
        }
        console.log('nzNeedNextCheckBox', this.sets.datas.nzNeedNextCheckBox)
        if (this.sets.datas.nzNeedNextCheckBox) {


            this.setService.pageDatas['needNextCheckBox'] = true;
        }
        else this.setService.pageDatas['needNextCheckBox'] = false;
        if (typeof this.setService.pageDatas['needNextCheckBoxValue'] == "undefined") {
            this.setService.pageDatas['needNextCheckBoxValue'] = false;
        }
        this.Listening();
        if (this.sets.datas.nzOtherFormCheck.length > 0) {
            this.pageService.pageDatas['formCheckData' + this.layoutid] = this.sets.datas.nzOtherFormCheck;
            console.log('formCheckData', this.layoutid, typeof this.pageService.pageDatas['formCheckData' + this.layoutid])

        }
    }

    autoUpdate() {

        //v3,升级自定义表单参数
        if (this.sets.versionCode < 2) {

            this.sets.blockCode = "sucublock29";

            this.sets.versionCode = 2;
        }

        //v3,存储过程
        if (this.sets.versionCode < 3) {
            if (typeof this.sets.datas.nzProcedure == "undefined") {
                this.sets.datas['nzProcedure'] = {
                    nzProcedureIsNeed: false,
                    nzProcedureTriggerPosition: "default",
                    nzProcedureName: "",
                    nzProcedureView: "",
                    nzServiceParam: [],
                    nzServiceParamDetail: { "sequ": 1 }
                }
            }
            this.sets.versionCode = 3;
        }
        // V4 按钮开放
        if (this.sets.versionCode < 4) {

            this.sets.styles['nzOpen'] = true;

            this.sets.versionCode = 4;
        }
        // V5 按钮确认
        if (this.sets.versionCode < 5) {

            this.sets.styles['nzConfirm'] = {
                nzShow: false,
                nzTitle: "提示",
                nzContent: "确定要删除吗？"
            };

            this.sets.versionCode = 5;
        }
        //vc:9
        //附加事件大整改
        if (this.sets.versionCode < 6) {
            for (const key in this.sets.datas.nzEventsDatas) {
                const element = this.sets.datas.nzEventsDatas[key];
                element['dataArray'] = [
                    element['datas']
                ];
                element['dataArray'][0]['blockid'] = element['blockid']


            }

            this.sets.versionCode = 6;
        }
        // V7 按钮开放
        if (this.sets.versionCode < 7) {

            this.sets.datas['nzOtherFormCheck'] = [];

            this.sets.versionCode = 7;
        }
        if (this.sets.versionCode < 8) {

            this.sets.datas['nzLog'] = ""

            this.sets.versionCode = 8;
        }


        if (this.sets.versionCode < 9) {

            this.sets.datas['nzLogSet'] = {
                defaultTitle: "SN:"
            },

                this.sets.versionCode = 9;
        }
        if (this.sets.versionCode < 10) {

            this.sets.styles['nzShow'] = true;
            this.sets.styles['nzShowValue'] = "";

            this.sets.versionCode = 10;
        }
        if (this.sets.versionCode < 11) {

            this.sets.styles['nzFastClick'] = false;

            this.sets.versionCode = 11;
        }
        if (this.sets.versionCode < 12) {

            this.sets.events = [
                {
                    label: "隐藏",
                    value: "pageShow",
                    data: {
                        setParams: ["隐藏值", '显示值，可不填', '备用']
                    }
                },
                {
                    label: "快速模式切换",
                    value: "fastForm",
                    data: {
                        setParams: ["快速值", '转圈值', '备用']
                    }
                }
            ],

                this.sets.versionCode = 12;
        }

        if (this.sets.versionCode < 13) {

            this.sets.styles['nzFastData'] = {
                nzResetId: "",
                nzResetFormName: "",
                nzCheck: false,
                nzCheckGroupName: ''
            }

            this.sets.versionCode = 13;
        }

        if (this.sets.versionCode < 14) {

            this.sets.datas['nzECO'] = true;
            this.sets.datas['nzSIC'] = '';
            this.sets.versionCode = 14;
        }
        if (this.sets.versionCode < 15) {

            this.sets.datas['nzFocus'] = {
                nzFocus1: "",
                nzFocus2: "",
                nzFocus3: "",
            }
            this.sets.versionCode = 15;
        }
        if (this.sets.versionCode < 16) {

            this.sets.datas['nzClickFocus'] = true
            this.sets.versionCode = 16;
        }
        if (this.sets.versionCode < 17) {

            this.sets.datas['nzNeedFromRefresh'] = false
            this.sets.versionCode = 17;
        }

        if (this.sets.versionCode < 18) {

            this.sets.datas['nzOtherData'] = [];
            this.sets.versionCode = 18;
        }

        if (this.sets.versionCode < 19) {

            this.sets.datas['nzDoEventFail'] = true;
            this.sets.versionCode = 19;
        }


    }

    private nzTimer;
    needCloseModal = false;
    needCloseValue = false;
    needCloseValueData = [];
    waitMain = false;
    waitMainData = [];

    endEvent = [];
    eventWorkflowId;
    async onClickEvents() {
        console.log('button009', this.sets.datas.nzEvents)

        this.endEvent = [];
        //按钮loading
        this.nzLoading = true;
        this.pageService.pageSpin[this.layoutid]['div'] = true;
        this.needCloseValue = false;
        //表单状态
        this.setService.addNeedStatus(this.blockid, 'submit', 'form', 'formsubmit');
        console.log(this.blockid, 'needStatus', JSON.stringify(this.setService.needStatus))
        this.waitMainData = [];
        this.sets.datas.nzEvents.forEach(element => {
            switch (element) {
                case 'workflow':

                    this.eventService.flowStatusTransfer(this.sets.datas.nzEventsDatas[element]['dataArray'][0]['blockid'], this.blockid);

                    this.eventWorkflowId = this.sets.datas.nzEventsDatas[element]['dataArray'][0]['blockid'];

                    break;
                case 'mainFirst':
                    console.log('mainFirst', this.sets.datas.nzEventsDatas[element])

                    this.waitMain = true;
                    this.sets.datas.nzEventsDatas[element]['dataArray'].forEach(element => {
                        this.waitMainData.push({
                            'blockid': element['blockid'],
                            'valuefield': element['param1'],
                            'field': element['param0'],
                        })
                    });

                    this.setService.addNeedStatus(this.blockid, 'submit', this.sets.datas.nzEventsDatas[element]['dataArray'][0]['blockid'], 'mainInsert')
                    this.setService.setPublicStatus(this.sets.datas.nzEventsDatas[element]['dataArray'][0]['blockid'], 'mainInsert', 'waitMainInsert')
                    break;
                case 'mainFirst2':
                    console.log('mainFirst2', this.sets.datas.nzEventsDatas[element])
                    this.waitMain = true;
                    this.sets.datas.nzEventsDatas[element]['dataArray'].forEach(element => {
                        this.waitMainData.push({
                            'blockid': element['blockid'],
                            'valuefield': element['param1'],
                            'field': element['param0'],
                        })
                    });

                    this.setService.addNeedStatus(this.blockid, 'submit', this.sets.datas.nzEventsDatas[element]['dataArray'][0]['blockid'], 'mainInsert')
                    this.setService.setPublicStatus(this.sets.datas.nzEventsDatas[element]['dataArray'][0]['blockid'], 'mainInsert', 'waitMainInsert2')
                    break;
                case 'closeAfterSuccess':
                    this.needCloseModal = true;
                    try {
                        console.log('closeAfterSuccess', this.sets.datas.nzEventsDatas[element]['dataArray'])
                        if (this.sets.datas.nzEventsDatas[element]['dataArray'][0]['param0'].length > 0) {
                            if (typeof this.sets.datas.nzEventsDatas[element]['dataArray'][0]['param0'] === 'object') {
                                this.needCloseValue = true;
                                this.needCloseValueData = this.sets.datas.nzEventsDatas[element]['dataArray'][0]['param0'];
                            }
                        }
                    } catch (error) {

                    }
                    console.log('closeAfterSuccess2', this.needCloseValue, this.needCloseValueData)

                    break
                case 'sendSimpleEvent':
                    this.sets.datas.nzEventsDatas[element]['dataArray'].forEach(itemEvents => {
                        if (itemEvents['order'] == "front") {
                            switch (itemEvents['name']) {
                                case 'search':
                                    break;
                                default:
                                    let senddata = { value: "" };
                                    try {
                                        senddata['param0'] = itemEvents['param0'];
                                        senddata['param1'] = itemEvents['param1'];
                                        senddata['param2'] = itemEvents['param2'];
                                    } catch (error) {

                                    }
                                    console.log("send", this.blockid, itemEvents['blockid'], itemEvents['name'], senddata)
                                    this.setService.sendEvent(itemEvents['blockid'], itemEvents['name'], senddata)
                                    break;
                            }
                        } else {
                            if (this.endEvent.indexOf(element) < 0) this.endEvent.push(element);
                            // this.endEvent.push(element);
                        }
                    });





                    break;

                default:
                    break;
            }
        });
        //判断是否需要调用存储过程
        if (this.sets.datas.nzProcedure.nzProcedureIsNeed) {
            console.log("procedureRes", 'init');
            this.setService.addNeedStatus(this.blockid, 'submit', this.blockid, 'procedure')
            this.setService.setPublicStatus(this.blockid, 'procedure', 'procedureRes')

            let serviceparams = this.pageService.getAllServiceParam(this.sets.datas['nzProcedure'], this.sets.datas['nzProcedure']['nzServiceParamDetail'], this.activatedRoute)
            console.log("获取业务参数1", serviceparams)
            serviceparams = await this.pageService.changeBodySn(serviceparams);
            console.log("获取业务参数2", serviceparams)
            let procedureParams = {
                dynamicSql: serviceparams[0].name,
                paramMap: serviceparams[0].compositeValue
            }


            if (typeof this.pageService.pageDatas[this.path] != "undefined" && typeof this.pageService.pageDatas[this.path]['SICBean'] != "undefined") {
                if (this.pageService.pageDatas[this.path]['SICBean'] != "")
                    procedureParams['resourceVerificationBean'] = this.pageService.pageDatas[this.path]['SICBean'];
            }
            //2.其它参数
            let resCode =
                await this.pageService.addProcedureParams(this.sets.datas.nzOtherData, procedureParams.paramMap);
            console.log("获取处理业务参数2", resCode, JSON.stringify(procedureParams), this.pageService.pageDatas[this.path])

            if (resCode !== 'ok') {
                console.log("获取参数失败resCode", resCode);
                this.setService.setPublicStatus(this.blockid, 'procedure', 'procedureRes', -1)
                return;
            }
            this.httpService.postHttp(this.httpUrls.dynamicProcedure.url, procedureParams).subscribe(
                (data: any) => {
                    console.log("业务data", JSON.stringify(data));
                    this.pageService.doAfterProcedure(data, this.sets);

                    this.pageService.doAfterProceduresecond(data, this.sets, this.activatedRoute);

                    try {
                        if (data.data[0]['CSYS_RETURN'] == 'fail')
                            this.setService.setPublicStatus(this.blockid, 'procedure', 'procedureRes', -1)
                        else
                            this.setService.setPublicStatus(this.blockid, 'procedure', 'procedureRes', 1)
                    } catch (error) {
                        this.setService.setPublicStatus(this.blockid, 'procedure', 'procedureRes', 1)

                    }
                    console.log('存储重置nzNeedFromRefresh', this.sets.datas.nzNeedFromRefresh);
                    if (this.sets.datas.nzNeedFromRefresh) {
                        console.log('存储重置')
                        const formData = this.setService.pageDatas['form_data_' + this.layoutid];
                        if (formData.datas.nzForm.nzFormType == 'insert') {
                            this.formControlService.form_Reset(this.setService.pageDatas['form_' + this.layoutid], formData, this.activatedRoute);
                        }

                    }
                    console.log(data.data);
                },
                (err: any) => {
                    console.log("业务dataerr", JSON.stringify(err));
                    this.setService.setPublicStatus(this.blockid, 'procedure', 'procedureRes', -1)
                });
        }
        //
        setTimeout(() => {

            this.nzTimer = setInterval(() => {
                let res = 1, fail = 0;
                console.log(this.blockid, 'publicStatus', JSON.stringify(this.setService.publicStatus))
                for (const key in this.setService.publicStatus[this.blockid]['submit']) {
                    const element = this.setService.publicStatus[this.blockid]['submit'][key];
                    if (element == -1) {
                        fail = 1;
                        console.log('error', `处理失败` + key);
                        this.nzLoading = false;
                        this.pageService.pageSpin[this.layoutid]['div'] = false;
                        //this.notification.blank('失败', key + '');
                        if (this.nzTimer) {
                            clearInterval(this.nzTimer);
                            this.nzTimer = null
                        }

                    } else {
                        if (element == 1) {
                            // this.notification.blank('成功', key + '');
                            console.log(key);
                            if (this.waitMain && key == 'insert') {
                                // console.log('主子send blockid', this.waitMainData);
                                let waitMainDataJson = {}
                                this.waitMainData.forEach(element => {
                                    console.log('主子send element', element);

                                    if (typeof waitMainDataJson[element['blockid']] == 'undefined') {
                                        waitMainDataJson[element['blockid']] = [];
                                    }
                                    waitMainDataJson[element['blockid']].push(
                                        {
                                            'valuefield': element['valuefield'],
                                            'field': element['field'],
                                        }
                                    )
                                });
                                for (const blockid in waitMainDataJson) {
                                    // console.log('主子send', {
                                    //     key: this.setService.publicStatus[this.blockid]['form'][key + 'data']['key'],
                                    //     field: waitMainDataJson[blockid],
                                    //     bodyData: this.setService.publicStatus[this.blockid]['form'][key + 'data']['bodyData']
                                    // })
                                    this.setService.sendEvent(blockid, 'mainFist',
                                        {
                                            key: this.setService.publicStatus[this.blockid]['form'][key + 'data']['key'],
                                            field: waitMainDataJson[blockid],
                                            bodyData: this.setService.publicStatus[this.blockid]['form'][key + 'data']['bodyData']
                                        }
                                    )

                                }

                            }
                            if ((key == 'insert' || key == 'update' || key == 'procedureRes') && this.waitMain == false) {
                                console.log('nzNeedRefresh');
                                if (this.sets.datas.nzNeedRefresh) {
                                    if (typeof this.setService.pageDatas['table_modal'] == 'undefined') {
                                        this.setService.pageDatas['table_modal'] = {
                                            isNeedRefresh: true
                                        }
                                    } else {
                                        this.setService.pageDatas['table_modal']['isNeedRefresh'] = true;
                                    }
                                }

                            }
                            else if (key == 'initFlow') {
                                console.log('工作流初始化-->');
                                console.log(this.setService.publicStatus[this.blockid][this.eventWorkflowId]['initFlow'])
                                let resultData = this.setService.publicStatus[this.blockid][this.eventWorkflowId]['initFlow']['data'];

                                console.log("工作流迁移数据-检测", resultData);

                                if (resultData.code == '200') {
                                    this.notification.create('success', '工作流',
                                        '工作流初始化成功。');
                                } else {
                                    this.notification.create('error', '工作流', resultData.msg);
                                }



                            }
                            else if (key == 'transfer') {
                                console.log('工作流迁移-->');

                                console.log(this.setService.publicStatus[this.blockid][this.eventWorkflowId]['transfer'])
                                let resultData = this.setService.publicStatus[this.blockid][this.eventWorkflowId]['transfer']['data'];

                                console.log("工作流迁移数据-检测", resultData);

                                if (resultData.code == '200') {
                                    this.notification.create('success', '工作流',
                                        '工作流迁移成功。');
                                } else {
                                    this.notification.create('error', '工作流', resultData.msg);
                                }

                            }
                            delete this.setService.publicStatus[this.blockid]['submit'][key];

                        }

                        res = res * element
                    }

                }
                if (fail == 0) {
                    if (res == 1) {
                        //全成功
                        console.log('全成功');
                        console.log('table_modal', JSON.stringify(this.setService.pageDatas['table_modal']));

                        //this.notification.blank('全成功', '全成功');
                        // this.message.create('success',`处理成功`);
                        //事后事件处理
                        this.endEvent.forEach(element => {
                            this.sets.datas.nzEventsDatas[element]['dataArray'].forEach(itemEvents => {
                                if (itemEvents['order'] == "back") {
                                    switch (itemEvents['name']) {
                                        case 'search':
                                            break;
                                        default:
                                            let senddata = { value: "" };
                                            try {
                                                senddata['param0'] = itemEvents['param0'];
                                                senddata['param1'] = itemEvents['param1'];
                                                senddata['param2'] = itemEvents['param2'];
                                            } catch (error) {

                                            }
                                            console.log("send", this.blockid, itemEvents['blockid'], itemEvents['name'], senddata)
                                            this.setService.sendEvent(itemEvents['blockid'], itemEvents['name'], senddata)
                                            break;
                                    }
                                }
                            });
                        });
                        this.nzLoading = false;
                        this.pageService.pageSpin[this.layoutid]['div'] = false;
                        if (this.nzTimer) {
                            clearInterval(this.nzTimer);
                            this.nzTimer = null
                        }
                        console.log(this.needCloseModal, this.sets.datas.nzNeedNextCheckBox, this.setService.pageDatas['needNextCheckBoxValue'])
                        if (this.needCloseModal) {//需要关

                            if (this.sets.datas.nzNeedNextCheckBox) {//有开关
                                //有开关并且没勾选继续
                                if (this.setService.pageDatas['needNextCheckBoxValue'] == false) this.closeWithValue();//没开关直接关
                            }
                            else this.closeWithValue();//没开关直接关
                        }
                    } else {
                        //还需等待
                    }
                } else {
                    this.message.create('error', `失败`);
                    if (this.sets.datas['nzDoEventFail']) {
                        //事后事件处理
                        this.endEvent.forEach(element => {
                            this.sets.datas.nzEventsDatas[element]['dataArray'].forEach(itemEvents => {
                                if (itemEvents['order'] == "back") {
                                    switch (itemEvents['name']) {
                                        case 'search':
                                            break;
                                        default:
                                            let senddata = { value: "" };
                                            try {
                                                senddata['param0'] = itemEvents['param0'];
                                                senddata['param1'] = itemEvents['param1'];
                                                senddata['param2'] = itemEvents['param2'];
                                            } catch (error) {

                                            }
                                            console.log("send", this.blockid, itemEvents['blockid'], itemEvents['name'], senddata)
                                            this.setService.sendEvent(itemEvents['blockid'], itemEvents['name'], senddata)
                                            break;
                                    }
                                }
                            });
                        });
                    }

                    this.nzLoading = false;
                    this.pageService.pageSpin[this.layoutid]['div'] = false;
                    if (this.nzTimer) {
                        clearInterval(this.nzTimer);
                        this.nzTimer = null
                    }
                }


            }, 300)
        }, 100);




    }

    closeWithValue() {
        if (this.needCloseValue) {
            let data = {};
            this.needCloseValueData.forEach(param => {
                if (param !== '') {
                    const paramdata = this.setService.pageDatas['form_data_' + this.layoutid].datas.nzServiceParamDetail[param];
                    data[paramdata['urlName']] = this.pageService.getServiceParam(paramdata, this.activatedRoute);
                }
            });
            console.log("传值关闭", this.setService.pageDatas['table_modal']['acceptBlockId'], data)
            if (this.setService.pageDatas['table_modal']['acceptBlockId'] !== undefined && this.setService.pageDatas['table_modal']['acceptBlockId'] !== '')
                this.setService.sendEvent(this.setService.pageDatas['table_modal']['acceptBlockId'], "setValues", data);
        }
        this.eventService.dialog_close();//没开关直接关
    }
    otherFormCheckStatus = {

    }
    isDoling: { [key: string]: boolean } = {}
    async onFastClick() {
        if (this.sets.styles.nzFastClick) {
            let needGroupCheck = false;

            if (this.sets.datas.nzProcedure.nzProcedureIsNeed) {

                const formData = this.setService.pageDatas['form_data_' + this.layoutid];

                const value = this.setService.pageDatas['form_' + this.layoutid].get(this.sets.styles.nzFastData.nzResetFormName).value || '';


                this.setService.pageDatas['form_' + this.layoutid].get(this.sets.styles.nzFastData.nzResetFormName).patchValue("");
                console.log('formData', formData)
                console.log("fastvalue", value)

                if (this.sets.styles.nzFastData.nzCheck) {
                    if (this.sets.styles.nzFastData.nzCheckGroupName) {
                        const groupValue = this.setService.pageDatas['form_' + this.layoutid].get(this.sets.styles.nzFastData.nzCheckGroupName).value;
                        if (groupValue === 1 || groupValue === '1') {
                            needGroupCheck = true;
                        }
                    }
                    if (!needGroupCheck) {
                        if (this.isDoling[value]) {
                            console.log('任务重复，已终止', value);
                            return;
                        }
                        console.log('任务执行', value);
                        this.isDoling[value] = true;
                    }
                }
                console.log("focus", this.sets.styles.nzFastData.nzResetId, formData)
                try {
                    if (this.pageService.pageDatas['LinkEvents' + this.sets.styles.nzFastData.nzResetId]) {
                        this.pageService.pageDatas['LinkEvents' + this.sets.styles.nzFastData.nzResetId].forEach(element => {
                            console.log('onFastClick-LinkEvents', element);

                            this.setService.sendEvent(element.blockid, "linkage" + element.type, { value: value })
                        });
                    }
                    if (formData['datas']['nzForm']['nzFormGroupDatas'][this.sets.styles.nzFastData.nzResetId]['nzValue']['nzValueFormat'] == 'focus') {
                        this.setService.events[this.sets.styles.nzFastData.nzResetId].emit({
                            type: 'focus',
                            datas: {}
                        })
                        console.log("focusok", this.sets.styles.nzFastData.nzResetId)
                    }

                } catch (error) {
                    console.log("focusokerr", error)

                }

                let serviceparams = this.pageService.getAllServiceParam(this.sets.datas['nzProcedure'], this.sets.datas['nzProcedure']['nzServiceParamDetail'], this.activatedRoute)
                // if (formData.datas.nzForm.nzFormType == 'insert') {
                //     this.formControlService.form_Reset(this.setService.pageDatas['form_' + this.layoutid], formData);
                // }


                console.log("获取业务参数", serviceparams)
                let procedureParams = {
                    dynamicSql: serviceparams[0].name,
                    paramMap: serviceparams[0].compositeValue
                }
                let barcodeGroupCode = '';
                if (value != "") {
                    for (let index = 0; index < serviceparams[0].compositeValue.length; index++) {
                        const paramsdata = serviceparams[0].compositeValue[index];
                        if (paramsdata.name == this.sets.styles.nzFastData.nzResetId) {
                            //转换判断
                            console.log('paramsdata', paramsdata.value);
                            try {
                                if (formData['datas']['nzForm']['nzFormGroupDatas'][this.sets.styles.nzFastData.nzResetId]['nzValue']['nzPipe'] === 'sn') {
                                    paramsdata.value = await this.pageService.getNewSn(value);
                                    console.log('snchange-end', paramsdata.value)

                                } else {
                                    paramsdata.value = value
                                }
                            } catch (error) {
                                paramsdata.value = value
                            }
                            // paramsdata.value = value
                            console.log('paramsdata', paramsdata.value, needGroupCheck);
                            if (needGroupCheck) {
                                const body = {
                                    "proBarCode": paramsdata.value
                                }
                                // 组逻辑判断
                                const groupData = await this.httpService.postHttp('barcodegroup/condition', body).toPromise();
                                if (groupData && groupData.data && groupData.data.length) {
                                    barcodeGroupCode = groupData.data[0].barcodeGroupCode || value;
                                } else {
                                    barcodeGroupCode = value;
                                }
                                if (this.isDoling[barcodeGroupCode]) {
                                    console.log('任务重复，已终止 group',value, barcodeGroupCode);
                                    return;
                                }
                                console.log('任务执行 group', value, barcodeGroupCode);

                                this.isDoling[barcodeGroupCode] = true;
                            }
                            break;
                        }
                    }

                }

                //事件
                let endEvent = [];
                this.sets.datas.nzEvents.forEach(element => {
                    switch (element) {

                        case 'sendSimpleEvent':
                            this.sets.datas.nzEventsDatas[element]['dataArray'].forEach(itemEvents => {
                                if (itemEvents['order'] == "front") {
                                    switch (itemEvents['name']) {
                                        case 'search':
                                            break;
                                        default:
                                            let senddata = { value: "" };
                                            try {
                                                senddata['param0'] = itemEvents['param0'];
                                                senddata['param1'] = itemEvents['param1'];
                                                senddata['param2'] = itemEvents['param2'];
                                            } catch (error) {

                                            }
                                            console.log("send-fast", this.blockid, itemEvents['blockid'], itemEvents['name'], senddata)
                                            this.setService.sendEvent(itemEvents['blockid'], itemEvents['name'], senddata)
                                            break;
                                    }
                                } else {
                                    if (endEvent.indexOf(element) < 0) endEvent.push(element);
                                }
                            });

                            break;

                        default:
                            break;
                    }
                });
                console.log("endEvent", endEvent)

                //参数再次处理
                //1.resourceVerificationBean
                if (typeof this.pageService.pageDatas[this.path] != "undefined" && typeof this.pageService.pageDatas[this.path]['SICBean'] != "undefined") {
                    if (this.pageService.pageDatas[this.path]['SICBean'] != "")
                        procedureParams['resourceVerificationBean'] = this.pageService.pageDatas[this.path]['SICBean'];
                }
                //2.其它参数 快速提交暂不支持
                // let resCode = await 
                //     this.pageService.addProcedureParams(this.sets.datas.nzOtherData, procedureParams.paramMap);
                console.log("获取处理业务参数2", JSON.stringify(procedureParams), this.pageService.pageDatas[this.path])

                // if (resCode !== 'ok') {
                //     console.log("获取参数失败resCode", resCode);
                //     this.setService.setPublicStatus(this.blockid, 'procedure', 'procedureRes', -1)
                //     return;
                // }

                //发送提示开始的日志
                let data = new Date().getTime() + '';
                let id = data.substring(data.length - 6, data.length - 1) + (Math.floor(Math.random() * (1 - 100)) + 100)
                console.log('data', data, (data + '').substring((data + '').length - 6, (data + '').length));
                this.setService.sendEvent(this.sets.datas.nzLog, 'addLogs2', {
                    datas: {
                        id: id,
                        title: value,
                        state: "loading",
                    }
                });
                this.httpService.postHttp(this.httpUrls.dynamicProcedure.url, procedureParams).subscribe(
                    (data: any) => {
                        console.log("业务data", JSON.stringify(data));

                        if (this.sets.styles.nzFastData.nzCheck) {
                            if (needGroupCheck && barcodeGroupCode) {
                                delete this.isDoling[barcodeGroupCode];
                            } else {
                                delete this.isDoling[value];
                            }
                        }

                        this.pageService.doAfterProcedure(data, this.sets, id);

                        this.pageService.doAfterProceduresecond(data, this.sets, this.activatedRoute, id);

                        //事后事件处理
                        console.log("doendEvent", endEvent, this.sets.datas.nzEventsDatas)
                        endEvent.forEach(element => {
                            this.sets.datas.nzEventsDatas[element]['dataArray'].forEach(itemEvents => {
                                if (itemEvents['order'] == "back") {
                                    switch (itemEvents['name']) {
                                        case 'search':
                                            break;
                                        default:
                                            let senddata = { value: "" };
                                            try {
                                                senddata['param0'] = itemEvents['param0'];
                                                senddata['param1'] = itemEvents['param1'];
                                                senddata['param2'] = itemEvents['param2'];
                                            } catch (error) {

                                            }
                                            console.log("send-fast", this.blockid, itemEvents['blockid'], itemEvents['name'], senddata)
                                            this.setService.sendEvent(itemEvents['blockid'], itemEvents['name'], senddata)
                                            break;
                                    }
                                }


                            });
                        });

                        console.log(data.data);
                    },
                    (err: any) => {
                        delete this.isDoling[value];
                        console.log("业务dataerr", JSON.stringify(err));
                    });
            }
        } else {
            this.onClick();
        }
    }
    otherFormCheckStatusMsgs = {};

    onClick(): void {
        this.otherFormCheckStatus = {};
        this.otherFormCheckStatusMsgs = {};
        console.log("elementRef", this.elementRef.nativeElement)
        if (this.sets.datas.nzClickFocus) {
            this.elementRef.nativeElement.querySelector('button').focus();
        }
        if (!this.sets.styles.nzOpen) {
            this.message.create('info', `功能暂未开放`);
        } else {
            //其它校验
            console.log("其它校验")
            this.nzLoading = true;
            let delayTime = 500;//max 1000
            if (this.sets.datas.nzOtherFormCheck.length > 0) {
                this.pageService.pageDatas['formCheckDataStatu' + this.layoutid] = false;
                console.log("其它校验", 'formCheckDataStatu' + this.layoutid)
                this.sets.datas.nzOtherFormCheck.forEach(element => {
                    switch (element.type) {
                        case 'childTable':
                            delayTime = 900;
                            if (this.otherFormCheckStatus[element.type] === null || this.otherFormCheckStatus[element.type] === undefined) {
                                this.otherFormCheckStatus[element.type] = true;
                            }
                            this.setService.sendEvent(element['datas']['blockid'], 'check_' + element.type, { blockid: this.blockid, num: element.datas.param0 })
                            break;
                        case 'hasTansfer':
                            this.otherFormCheckStatus[element.type] = false;
                            this.setService.sendEvent(element['datas']['blockid'], 'check_' + element.type, { blockid: this.blockid, num: element.datas.param0 })
                            break;
                        case 'hiddenvalue':
                            if (this.otherFormCheckStatus[element.type] === undefined) {
                                this.otherFormCheckStatus[element.type] = true;
                                this.otherFormCheckStatusMsgs[element.type] = [];
                            }

                            const formid = this.setService.pageDatas['form_data_' + this.layoutid].datas.nzForm.nzFormGroupDatas[element['datas']['blockid']]['nzKey'];
                            if (this.setService.pageDatas['form_' + this.layoutid].get(formid).value === '' || this.setService.pageDatas['form_' + this.layoutid].get(formid).value === null) {
                                this.otherFormCheckStatus['hiddenvalue'] = false;
                                if (element['datas']['param1'] !== '')
                                    this.otherFormCheckStatusMsgs[element.type].push(element['datas']['param1']);
                            }

                            break;

                        default:
                            break;
                    }
                });
                setTimeout(() => {
                    let status = true;

                    for (let index = 0; index < this.sets.datas.nzOtherFormCheck.length; index++) {
                        const type = this.sets.datas.nzOtherFormCheck[index]['type'];
                        if (!this.otherFormCheckStatus[type]) {
                            status = false;

                            if (this.sets.datas.nzOtherFormCheck[index]['datas']['param1'] !== '') {
                                if (this.otherFormCheckStatusMsgs[type] === undefined)
                                    this.message.error(this.sets.datas.nzOtherFormCheck[index]['datas']['param1']);
                                else {
                                    if (this.otherFormCheckStatusMsgs[type].length >= 0) {
                                        this.otherFormCheckStatusMsgs[type].forEach(msg => {
                                            this.message.error(msg);
                                        });

                                    }
                                }
                            }


                            break;

                        }
                    }
                    console.log("其它校验status", status, this.otherFormCheckStatus, this.sets.datas.nzOtherFormCheck)
                    this.nzLoading = false;

                    if (status) {
                        this.pageService.pageDatas['formCheckDataStatu' + this.layoutid] = true;
                        if (this.sets.styles.nzConfirm.nzShow) {
                            this.modalService.confirm({
                                nzTitle: this.sets.styles.nzConfirm.nzTitle,
                                nzContent: this.sets.styles.nzConfirm.nzContent,
                                nzOnOk: () => this.onClickEvents()
                            });
                        }
                        else {
                            this.onClickEvents();
                        }
                    }

                }, delayTime);
            } else {
                if (this.sets.styles.nzConfirm.nzShow) {
                    this.modalService.confirm({
                        nzTitle: this.sets.styles.nzConfirm.nzTitle,
                        nzContent: this.sets.styles.nzConfirm.nzContent,
                        nzOnOk: () => this.onClickEvents()
                    });
                }
                else {
                    this.onClickEvents();
                }
            }



        }

    }
    ngOnDestroy() {
        console.log("ngOnDestroy注销");
        if (this.nzTimer) {
            clearInterval(this.nzTimer);
        }
        this.setService.deleteEvent(this.blockid);	//注销	

    }
    nzShow = true;
    Listening() {
        setTimeout(() => {
            this.setService.initEvent(this.blockid);
            this.setService.events[this.blockid].subscribe(
                data => {
                    console.log("Listening:", data['type'], JSON.stringify(data));
                    let array0 = []
                    let array1 = []
                    switch (data['type']) {

                        case 'check_childTable_ans':
                            console.log("check_childTable_ans:", this.otherFormCheckStatus['childTable'], data.datas);

                            if (data.datas) {
                                // this.otherFormCheckStatus['childTable'] = true;
                            } else {
                                this.otherFormCheckStatus['childTable'] = false;
                            }
                            console.log("check_childTable_ans:2", this.otherFormCheckStatus['childTable']);


                            break;
                        case 'check_hasTansfer_ans':
                            if (data.datas)
                                this.otherFormCheckStatus['hasTansfer'] = true;

                            break;
                        case 'pageShow':

                            console.log("data.datas.value", data.datas.value, data.datas.param0)
                            array0 = (data.datas.param0 + "").split(",");
                            array1 = (data.datas.param1 + "").split(",");
                            if (array0.indexOf(data.datas.value) >= 0) {
                                //disable
                                this.sets['styles']['nzShow'] = false;

                            } else if (array1.indexOf(data.datas.value) >= 0 || data.datas.param1 == "") {
                                // enable
                                this.sets['styles']['nzShow'] = true;
                                // this.form.get(this.nzFormGroupData.nzKey).enable();
                            }
                            break;
                        case 'fastForm':

                            console.log("data.datas.value", data.datas.value, data.datas.param0)
                            array0 = (data.datas.param0 + "").split(",");
                            array1 = (data.datas.param1 + "").split(",");
                            if (array0.indexOf(data.datas.value) >= 0) {
                                //disable
                                this.sets.styles['nzFastClick'] = true;
                                this.setService.pageDatas['form_data_' + this.layoutid].datas.nzForm.nzFastClick = true;
                            } else if (array1.indexOf(data.datas.value) >= 0 || data.datas.param1 == "") {
                                // enable
                                this.sets.styles['nzFastClick'] = false;
                                this.setService.pageDatas['form_data_' + this.layoutid].datas.nzForm.nzFastClick = false;
                                // this.form.get(this.nzFormGroupData.nzKey).enable();
                            }
                            break;
                        case 'click':
                            this.onFastClick();
                            break;

                        default:
                            break;
                    }
                }
            )
        }, !this.static ? 100 : 0);


    }

}








